import { SnackbarsStackAction, SNACKBARS_STACK_DELETE } from './types';
import { SnackbarId } from '../types';

export const deleteSnackbar = (
  snackbarId: SnackbarId
): SnackbarsStackAction => ({
  type: SNACKBARS_STACK_DELETE,
  payload: snackbarId
});
